<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="600px">
    <v-card class="px-3 py-0">
      <v-card-title class="pa-0">
        <v-col class="text-right pb-0 pt-1 px-0">
          <v-btn icon dark @click="close()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0 pb-3" cols="12">
          <h1 style="font-size: 26px" class="mb-1 pt-0"> Aplicar à todos da seleção</h1>
          <b>{{total}} {{tipo_consulta=='guias' ?`${tipo_consulta} serão afetadas.` :`${tipo_consulta} serão afetados.`}}</b>
        </v-col>
        <v-col v-if="valoresIguais && tipo_consulta=='itens'" class="text-list text-center px-0 py-2">
          <span><small>Vl. glosado (R$):</small> <b><span style="color:red">{{ formData.valor_glosado | formatPrice }}</span></b></span>
          <span v-if="formData.valor_acatado && tipo_consulta=='itens'"> / <small>Vl. acatado (R$):</small> <b><span>{{ formData.valor_acatado | formatPrice }}</span></b></span>
        </v-col>
      </v-card-title>
      <v-card-text class="py-0">
       <v-form ref="edicaoMassaForm">
        <v-row class="py-3 px-4">
            <v-col class="px-2 py-0" cols="12">
                <label>Justificativa</label>
                <v-text-field
                    v-model="formData.data.justificativa"
                    persistent-hint
                    outlined
                    dense
                    :rules=" RegraVariavel  ? [formRules.requiredField,this.formRules.maxLengthRule(this.LimiteCaracteres)] : (Regra500 ?[formRules.requiredField,formRules.max500] : [formRules.requiredField,formRules.max150])"
                  ></v-text-field>
            </v-col>
            <v-col class="px-0 py-0" cols="12">
              <formDadosExtras
              :itemSelecionado="null"
              tipo="Recurso"
              :dadosExtrasConfig="dadosExtrasConfig"
              :grupoEconomico="grupoEconomico"
              :dialog="dialog"
              :retornoForm="(condi) => retornoFormData(condi)"
              :formDataPre="formDataPre"
              :reapresentacao="reapresentacao"
              idForm="FormRecursoMassa"
            />
            <formDadosExtras
              v-if="reapresentacao"
              :itemSelecionado="null"
              tipo="Reapresentacao"
              :dadosExtrasConfig="dadosExtrasConfig"
              :grupoEconomico="grupoEconomico"
              :dialog="dialog"
              :retornoForm="(condi) => retornoFormData(condi)"
              :formDataPre="formDataPre"
              :reapresentacao="reapresentacao"
              idForm="FormReapresentacaoMassa"
            />
            </v-col>
            <v-col class="px-2 py-0" cols="4" v-if="valoresIguais && tipo_consulta=='itens'">
                <label>Valor recursado</label>
                  <v-text-field
                    v-model="formData.valorRecursado"
                    persistent-hint
                    class="my-0"
                    outlined
                    dense
                    @input="formatPrice(formData)"
                    @blur="formatPrice(formData)"
                  ></v-text-field>
            </v-col>
            <v-col class="px-2 py-0 pt-1" cols="8" v-show="edicaoMassa">
               <v-radio-group 
                v-model="formData.data.recursado_total" 
                row 
                small 
                @change="updateData(formData)" 
                :rules="tipo_consulta=='guias' && formData.data.recursado_total == null 
                  || !valoresIguais && formData.data.recursado_total == null 
                  ?formRules.required :[]"
                >
                <v-radio
                small
                    label="Acatar integral"
                    :value="false"
                ></v-radio>
                <v-radio
                small
                    label="Recursar integral"
                    :value="true"
                ></v-radio>
            </v-radio-group>
            </v-col>
        </v-row>
       </v-form>
      </v-card-text>
      <v-card-actions class="px-9">
          <v-btn
          outlined
            color="primary"
            height="30px"
            small
            depressed
            @click="close()"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            height="30px"
            small
            depressed
            @click="saveSelect(formData)"
          >
            Salvar edição
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

import formDadosExtras from "@/components/recebiveis/recursos_de_glosa_edicao/formDadosExtras"
moment.locale("pt-BR");
export default {
  components:{
    formDadosExtras
  },
  data() {
    return {
      formData:{
        data: {
          id: [],
          justificativa: null,
          recursado_total: null,
          valor_recursado: null,
          obj_type: null,
          dados_extras: null
        },
        valorRecursado: null,
        valor_glosado: null,
        valor_acatado: null,
      },
      valoresIguais: null,
      isEdicaoMassa: [],
      condi: false,
      dadosExtrasPorTipo: {Recurso:[]},
      Regra500: false,
      RegraVariavel : false,
      LimiteCaracteres: 0
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  watch: {
    dialog(bool){
      if (bool) {
        this.isEdicaoMassa = this.edicaoMassa[this.tipo_consulta].filter(el => el.selected==true || el.selected==false)
        this.formData.data.id = this.isEdicaoMassa.map(el => el.id)
        this.formData.data.obj_type = this.tipo_consulta == 'guias' ?'guia' :'item'
        // Trata os valores e retorna um boolean afirmando se as condições do array são iguais ou não
        this.valoresIguais = this.tipo_consulta == 'itens' && this.isEdicaoMassa.length > 1 
        ?this.isEdicaoMassa.reduce((unique, item) => unique.includes(item.valor_glosado) && item.selected 
        ? unique : [...unique, item.valor_glosado], []).length==1 : false
        // this.valoresIguais = this.isValoresIguais ?this.isValoresIguais :this.valoresIguais
        
        if (this.valoresIguais ) {
          this.formData.valor_glosado = this.isEdicaoMassa[0].valor_glosado
          this.formData.valorRecursado = '0,00'
        }
        if (this.tipo_consulta == 'itens' && this.isValoresIguais) {
          this.formData.valor_glosado = this.valValoresIguais
          this.formData.valorRecursado = '0,00'
          this.valoresIguais = true
        }
      } 
    },
    parametros(param){
        this.Regra500 = (param && param.RG_Versao && param.RG_Versao >= 40000)? true: false; 
        this.RegraVariavel  = param && param.RG_QTD_CARACTERES_JUSTIFICATIVA ? true: false; 
        this.LimiteCaracteres = param.RG_QTD_CARACTERES_JUSTIFICATIVA
    }
  },
  methods: {
    updateData(formData) {
      if (this.tipo_consulta == 'itens') {
        if (!formData.data.recursado_total) {
          formData.valorRecursado = 0
          formData.valor_acatado = formData.valor_glosado
        } else {
          formData.valor_acatado = 0
          formData.valorRecursado = formData.valor_glosado
        } if (this.valoresIguais) {
          this.formatPrice(formData)
        }
      }
    },
    formatPrice(item) {
      let value = !isNaN(parseFloat(item['valorRecursado'])) && isFinite(item['valorRecursado']) 
        ?(Number(item['valorRecursado'].toString().replace(',', '.'))/1).toFixed(2).replace(/[^\d]+/g,'') 
        :item['valorRecursado'].toString().replaceAll(/(!\d|\.|,)/g, '')
      let recurso = Number((Number(value)/100).toFixed(2))
      recurso = recurso > item.valor_glosado ?item.valor_glosado :recurso
      item.valor_acatado = item.valor_glosado - recurso
      let val = (Number(recurso.toString().replace(',', '.'))/1).toFixed(2).replace('.', ',')
      let result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      if (recurso >= item.valor_glosado) {
        setTimeout(() => {
          item['valorRecursado'] = result
          item.data.recursado_total = true
          item.data.valor_recursado = null
        },100)
      } else {
        if (item['valorRecursado'] == '0,0' || item['valorRecursado'] == '0,000') {
          setTimeout(() => {
            item['valorRecursado'] = result
            item.data.recursado_total = false
            item.data.valor_recursado = null
          },100)
        } else {
          item.data.recursado_total = recurso== item.valor_glosado ? true : recurso== 0 ? false : recurso> 0 && recurso< item.valor_glosado ?null :null
          item.data.valor_recursado = recurso== item.valor_glosado ? null : recurso== 0 ? null : recurso> 0 && recurso< item.valor_glosado ?recurso :recurso
          item['valorRecursado'] = result
        }
      }
    },
    saveSelect(formData) {
      console.log("saveSelect",this.$refs.edicaoMassaForm.validate(), formData.data.dados_extras)
      this.formData.data.dados_extras = {}
      if (this.$refs.edicaoMassaForm.validate() && (this.condi || formData.data.dados_extras == null || !formData.data.dados_extras.length))
      { 
        formData.data.pagamento_id = this.pagamento_id
        formData.data.dados_extras = JSON.stringify(this.formDataPre)
        this.save(formData.data)
      }
    },
    retornoFormData(condi){
      this.condi = condi
    },
  },
  props: {
    close: Function,
    dadosExtrasConfig: Object,
    dialog: Boolean,
    edicaoMassa: Object,
    filterData: Object,
    formDataPre: Object,
    grupoEconomico: Number,
    isValoresIguais: Boolean,
    pagamento_id: String,
    parametros: Object,
    reapresentacao: Boolean,
    save: Function,
    tipo: String,
    tipo_consulta: String,
    total: Number,
    valValoresIguais: Number,
  },
}
</script>

<style>

</style>